import { createRouter, createWebHistory } from "vue-router";
import { ReviseMeta } from "@/util/meta";
import { deviceType } from "@/util/base";

function createAdRoutes(platforms) {
  return platforms.flatMap(({ prefix, versions, componentMap }) =>
    versions.map((version) => ({
      path: `${prefix}-${version}`,
      name: `${prefix}-${version}`,
      component: () =>
        import(`./views/down/${componentMap[version] || version}.vue`),
    }))
  );
}
const adRoutesVersions = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "A2",
  "B2",
  "C2",
  "D2",
];

// 特殊映射
const adRoutesComponentMap = { L: "L", M: "M" };

const adRoutes = createAdRoutes([
  {
    prefix: "TT", // 抖音
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
  {
    prefix: "FB", // 脸书
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
  {
    prefix: "GG", // 谷歌
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
  {
    prefix: "line", // line
    versions: adRoutesVersions,
    componentMap: adRoutesComponentMap,
  },
]);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 入口页面
    {
      path: "/",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！下載送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！下載送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    // 预约页
    {
      path: "/pre",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！下載送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/pre/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！下載送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    // 广告投放营销预约页FB-X渠道
    {
      path: "/pre/FB2",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/pre/FB2/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/pre/FB",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/pre/FB/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    // 广告投放营销预约页GG-Y渠道
    {
      path: "/pre/GG2",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/pre/GG2/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/pre/GG",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/pre/GG/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    // 广告投放营销预约页TT-Z渠道
    {
      path: "/pre/TT2",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/pre/TT2/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/pre/TT",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/pre/TT/m",
      component: () => import("./views/yy/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    // 官网首页
    {
      path: "/home",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！下載送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/home/m",
      component: () => import("./views/yygw/index.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！下載送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    // 官网新闻
    {
      path: "/news",
      component: () => import("./views/yygw/news.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！下載送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/news/m",
      component: () => import("./views/yygw/news.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！下載送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    // 官网内容
    {
      path: "/content",
      component: () => import("./views/yygw/content.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！下載送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    {
      path: "/content/m",
      component: () => import("./views/yygw/content.vue"),
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！下載送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
    },
    // 游戏联动活动页
    {
      path: "/crossover",
      component: () => import("./views/crossover/index.vue"),
      meta: {
        title: "《RO仙境傳説：曙光》與RO端遊專屬聯動活動，參與可領三重好禮！",
        description:
          "《RO仙境傳説：曙光》、《RO仙境傳說Online》《RO仙境傳說Online：樂園》進行專屬聯動活動，在《RO仙境傳説：曙光》遊戲內達成相應條件，即可獲得包括《RO仙境傳説：曙光》的【卡片扭蛋】【裝備扭蛋】【5級寶石自選】與《RO仙境傳說Online》的【附魔票】【防具精鍊能力+10券】等雙重好禮！參與《RO仙境傳說Online：樂園》聯動頁活動更可獲得加碼的三重獎勵！",
        keywords:
          "RO,ROL,ROtwilight,仙境傳説,曙光，RO仙境傳說Online，RO仙境傳說Online：樂園，RO端遊,MMORPG,RPG遊戲,重力社,GRAVITY,巴風特,經典遊戲,RO仙境傳說官網，專屬聯動",
      },
    },
    {
      path: "/crossover/m",
      component: () => import("./views/crossover/index.vue"),
      meta: {
        title: "《RO仙境傳説：曙光》與RO端遊專屬聯動活動，參與可領三重好禮！",
        description:
          "《RO仙境傳説：曙光》、《RO仙境傳說Online》《RO仙境傳說Online：樂園》進行專屬聯動活動，在《RO仙境傳説：曙光》遊戲內達成相應條件，即可獲得包括《RO仙境傳説：曙光》的【卡片扭蛋】【裝備扭蛋】【5級寶石自選】與《RO仙境傳說Online》的【附魔票】【防具精鍊能力+10券】等雙重好禮！參與《RO仙境傳說Online：樂園》聯動頁活動更可獲得加碼的三重獎勵！",
        keywords:
          "RO,ROL,ROtwilight,仙境傳説,曙光，RO仙境傳說Online，RO仙境傳說Online：樂園，RO端遊,MMORPG,RPG遊戲,重力社,GRAVITY,巴風特,經典遊戲,RO仙境傳說官網，專屬聯動",
      },
    },
    // 下载
    {
      path: "/down",
      meta: {
        title:
          "《RO仙境傳説：曙光》-RO首款「英雄雙生冒險RPG」手遊！預約送稀有坐騎、時裝&翅膀",
        description:
          "英雄變身，MVP怪物進化，重生RO當巴風特！-《RO仙境傳説：曙光》預約送稀有坐騎、時裝&翅膀-離線闖關、專屬MVP等放置玩法讓你輕鬆踏上冒險之旅！",
        keywords:
          "RO、ROL、ROtwilight、仙境傳説、曙光、、放推冒險團、守愛,新世代,愛如初見,重生,初心,一定要可愛RPG、MMORPG、RPG游戲、RO重生、重力社,GRAVITY,巴風特、經典遊戲、RO仙境傳說官网,RO線上版",
      },
      children: adRoutes,
    },
    // 404
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../../components/404.vue"),
    },
    // 测试
    {
      path: "/test",
      component: () => import("./views/test.vue"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  // 路由发生变化改变 description 和 keyword
  ReviseMeta(to.meta.title, to.meta.keywords, to.meta.description);

  // 定义特殊页面白名单，使用正则表达式匹配通配符
  const specialPages = [/^\/down(\/.*)?$/];

  // 检查当前路径是否在特殊页面白名单中
  const isSpecialPage = specialPages.some((pattern) => pattern.test(to.path));

  // 如果是特殊页面，直接调用 next()
  if (isSpecialPage) {
    next();
    return;
  }

  const isWap = deviceType() == "wap";

  // 定义PC端和移动端路径
  let pcPath = to.path.replace(/\/m$/, "");
  let wapPath = pcPath.endsWith("/") ? `${pcPath}m` : `${pcPath}/m`;

  // 根据设备类型跳转，避免重复添加或删除斜杠
  if (isWap && !to.path.endsWith("/m")) {
    next({ path: wapPath, query: to.query });
  } else if (!isWap && to.path.endsWith("/m")) {
    next({ path: pcPath, query: to.query });
  } else {
    next();
  }
});

export default router;
